import { IconButton, Popover, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React, { useState } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { iconButtonTouchTargetSx } from '../../utils/a11y.utils';

const CustomPopover = ({ content, isActiveFlag, fieldName, onInfoClick }) => {
	const { t } = useTranslation();
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
		onInfoClick?.(fieldName);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleKeyDown = (event) => {
		if (event.key === 'Escape') {
			handleClose();
		}
	};

	const open = Boolean(anchorEl);
	const id = open
		? fieldName === 'purpose'
			? 'purpose-popover'
			: 'accountInfo-popover'
		: undefined;
	const infoLabel = `${t('common.buttons.info')} ${fieldName}`;

	return (
		<div>
			<Tooltip title={open ? '' : infoLabel}>
				<IconButton
					size="small"
					onClick={handleClick}
					onKeyDown={handleKeyDown}
					aria-label={infoLabel}
					aria-expanded={open}
					aria-controls={open ? id : undefined}
					sx={{ p: 0.25, ...iconButtonTouchTargetSx }}
				>
					<InfoOutlinedIcon
						color={isActiveFlag ? 'primary' : 'disabled'}
						sx={{ fontSize: 16 }}
					/>
				</IconButton>
			</Tooltip>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				disableRestoreFocus={false}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				PaperProps={{
					role: 'region',
					'aria-label': infoLabel,
				}}
			>
				<div>{content}</div>
			</Popover>
		</div>
	);
};

export default CustomPopover;
